import Swiper, {Autoplay, Pagination, Navigation, A11y} from 'swiper';
import { debounce } from 'throttle-debounce';

window.addEventListener('DOMContentLoaded', () => {
  initMvSlide();
  initEventSlide();
  initContentFilter('.hrd__content.-future');
  initContentFilter('.hrd__content.-entre');
  initScrollToTop();
  initAdjustContent();
  initAdjustEvent();
  initModal();
});

// MVのスライド
function initMvSlide() {
  const outer = document.querySelector('.hrd__mv__slidesOuter');
  const wrapper = document.querySelector('.hrd__mv__slidesWrapper');

  let swiper = null;
  let isPlay = true;

  function buildMvSlide() {
    if (swiper) {
      swiper.destroy();
    }

    setTimeout(() => {

    const slideCount = document.querySelectorAll('.hrd__mv__slide').length;
    const slideCountDouble = slideCount * 2;

    swiper = new Swiper(wrapper, {
      modules: [Pagination, Navigation, Autoplay, A11y],
      slidesPerView: 'auto',
      speed: 1000,
      loop: true,
      pagination: {
        el: ".hrd__mv__slidesWrapper__nav__dots",
        bulletClass: 'm-slideNav__dot',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}" tabindex="0" aria-label="${index+1}枚目のスライド"></span>`;
        },
      },
      navigation: {
        prevEl: '.hrd__mv__slidesWrapper__nav__arrow.swiper-button-prev',
        nextEl: '.hrd__mv__slidesWrapper__nav__arrow.swiper-button-next',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 36,
        }
      },
      a11y: {
        prevSlideMessage: '前のスライドへ',
        nextSlideMessage: '次のスライドへ',
        paginationBulletMessage: '{{index}}枚目のスライドを表示',
      },
      on: {
        afterInit: s => {
          if (!isPlay) {
            s.autoplay.stop();
          }
        },
        activeIndexChange: s => {
          const slides = wrapper.querySelectorAll('.hrd__mv__slide');
          for (let i = 0; i < slides.length; i++) {
            let slide = slides[i];
            const anchor = slide.querySelector('a.hrd__mv__slide__link');
            if (anchor) {
              const tabindex = (i === s.activeIndex) ? '0' : '-1';
              anchor.setAttribute('tabindex', tabindex);
            }
          }
        },
        slideChangeTransitionEnd: s => {
          if (s.activeIndex === slideCountDouble && s.previousIndex === (slideCountDouble - 1)) {
            wrapper.classList.add('-stopAnimation');
            s.slideTo(slideCount, 0);
          } else if (s.activeIndex === (slideCount - 1) && s.previousIndex === slideCount) {
            wrapper.classList.add('-stopAnimation');
            s.slideTo((slideCountDouble - 1), 0);
          }
        },
        beforeSlideChangeStart: s => {
          if (!(s.activeIndex === slideCountDouble && s.previousIndex === (slideCountDouble - 1)) &&
              !(s.activeIndex === (slideCount - 1) && s.previousIndex === slideCount)) {
            wrapper.classList.remove('-stopAnimation');
          }
        },
        autoplayResume: s => {
          if (!isPlay) {
            setTimeout(() => {
              // pauseOnMouseEnterを設定すると、マウスを外した時に停止ボタンがONでも
              // 1回だけ次のスライドに進んでしまう問題のワークアラウンド。
              // 原因は、swiperが設定するmouseleaveイベントが、s.autoplay.runningがどうであれ、
              // s.autoplay.run()を実行してしまうこと（バグ）。
              s.autoplay.running = true;  // s.autoplay.runningがfalseだとstop()が実行できないので、実行できるようにする（run()はrunningをtrueにしない）
              s.autoplay.stop();  // run()で予約した次のスライドへの移動をキャンセルする
            });
          }
        },
      },
    });
    }, 500)
  }

  buildMvSlide();

  if (window.__MEDIA === 'PC') {
    const buildMvSlideOnResize = debounce(500, buildMvSlide);
    window.addEventListener('resize', buildMvSlideOnResize);
  }

  // 一時停止ボタン
  const pause = document.querySelector('.hrd__mv__slidesWrapper__nav__pause');
  pause.addEventListener('click', () => {
    if (outer.classList.contains('-paused')) {
      outer.classList.remove('-paused');
      swiper.autoplay.start();
      isPlay = true;
    } else {
      outer.classList.add('-paused');
      swiper.autoplay.stop();
      isPlay = false;
    }
    pause.setAttribute('aria-pressed', !isPlay);
  });
}

// イベントのスライド
function initEventSlide() {
  const wrapper = document.querySelector('.hrd__event__eventsWrapper');

  let isPlay = true;

  const swiper = new Swiper(wrapper, {
    modules: [Pagination, Navigation, Autoplay, A11y],
    slidesPerView: 'auto',
    spaceBetween: 28,
    speed: 500,
    loop: true,
    pagination: {
      el: ".hrd__event__eventsWrapper__nav__dots",
      bulletClass: 'm-slideNav__dot',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}" tabindex="0" aria-label="${index+1}枚目のスライド"></span>`;
      },
    },
    navigation: {
      prevEl: '.hrd__event__eventsWrapper__nav__arrow.swiper-button-prev',
      nextEl: '.hrd__event__eventsWrapper__nav__arrow.swiper-button-next',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 36,
      }
    },
    a11y: {
      prevSlideMessage: '前のスライドへ',
      nextSlideMessage: '次のスライドへ',
      paginationBulletMessage: '{{index}}枚目のスライドを表示',
    },
    on: {
      afterInit: s => {
        const options = {
          root: document.querySelector('.hrd__event__eventsWrapper'),
          threshold: [0,1],
        };
        const observer = new IntersectionObserver(entries => {
          for (let entry of entries) {
            const anchor = entry.target.querySelector('a.hrd__event__event__link');
            if (anchor) {
              const tabindex = (entry.intersectionRatio === 1) ? '0' : '-1';
              anchor.setAttribute('tabindex', tabindex);
            }
          }
        }, options);
        for (let slide of s.slides) {
          observer.observe(slide);
        }
      },
      autoplayResume: s => {
        if (!isPlay) {
          setTimeout(() => {
            // pauseOnMouseEnterを設定すると、マウスを外した時に停止ボタンがONでも
            // 1回だけ次のスライドに進んでしまう問題のワークアラウンド。
            // 原因は、swiperが設定するmouseleaveイベントが、s.autoplay.runningがどうであれ、
            // s.autoplay.run()を実行してしまうこと（バグ）。
            s.autoplay.running = true;  // s.autoplay.runningがfalseだとstop()が実行できないので、実行できるようにする（run()はrunningをtrueにしない）
            s.autoplay.stop();  // run()で予約した次のスライドへの移動をキャンセルする
          });
        }
      },
    },
  });

  // 一時停止ボタン
  const pause = document.querySelector('.hrd__event__eventsWrapper__nav__pause');
  pause.addEventListener('click', () => {
    if (wrapper.classList.contains('-paused')) {
      wrapper.classList.remove('-paused');
      swiper.autoplay.start();
      isPlay = true;
    } else {
      wrapper.classList.add('-paused');
      swiper.autoplay.stop();
      isPlay = false;
    }
    pause.setAttribute('aria-pressed', !isPlay);
  });
}

// コンテンツの絞り込み
function initContentFilter(selector) {
  const container = document.querySelector(selector);
  const typeElements = container.querySelectorAll('.hrd__content__type__anchor');

  // 選択中のタイプ
  let selectedTypes = [];

  function filter(e) {
    // 選択したか、選択を外したか
    let isSelect = false;


    // 選択中のタイプを更新
    const type = e.currentTarget.dataset.type;
    if (type === 'all') {
      selectedTypes = [];
      isSelect = true;
    } else {
      if (selectedTypes.includes(type)) {
        selectedTypes = selectedTypes.filter(t => t !== type);
      } else {
        selectedTypes = [...selectedTypes, type];
        isSelect = true;
      }
    }

    // 絞り込み条件の表示を更新
    for (let typeElement of typeElements) {
      if (selectedTypes.includes(typeElement.dataset.type) ||
          (selectedTypes.length === 0 && typeElement.dataset.type === 'all')) {
        typeElement.classList.add('-selected');
        typeElement.setAttribute('aria-checked', true);
      } else {
        typeElement.classList.remove('-selected');
        typeElement.setAttribute('aria-checked', false);
      }
    }

    // コンテンツの表示を更新
    const contents = container.querySelectorAll('.hrd__content__content');
    for (let content of contents) {
      // 選択時のアニメーション
      if (isSelect && (type === 'all' || content.classList.contains(`-${type}`))) {
        content.addEventListener('animationend', () => {
          content.classList.remove('-animating');
        }, {once: true});
        content.classList.add('-animating');
      }


      // 半透明状態を更新
      const anchor = content.querySelector('.hrd__content__content__link');
      if (selectedTypes.length === 0 ||
          selectedTypes.some(t => content.classList.contains(`-${t}`))) {
        content.classList.remove('-hidden');
        anchor.setAttribute('tabindex', '0');
      } else {
        content.classList.add('-hidden');
        anchor.setAttribute('tabindex', '-1');
      }
    }
  }

  for (let typeElement of typeElements) {
    typeElement.addEventListener('click', filter);
    typeElement.addEventListener('keydown', e => {
      if (e.key === ' ') {
        e.preventDefault();
      }
    });
    typeElement.addEventListener('keyup', e => {
        if (e.key === ' ') {
            filter(e);
            e.stopPropagation();
        }
    });
  }
}

function initScrollToTop() {
  const top = document.querySelector('.hrd__footer__top__anchor');
  top.addEventListener('click', () => {
    window.scrollTo(0,0);
  })
}

// 画面幅に応じてコンテンツに設定されているモディファイアを変更する。
// CSS側が複雑になりすぎているので、js側でもサポートして複雑さを低減する
function initAdjustContent() {
  function adjustContent() {
    // const futureContent9 = document.querySelector('.-future .hrd__content__content.-content9');
    // const entreContent10 = document.querySelector('.-entre .hrd__content__content.-content10');

    if (window.__MEDIA === 'PC') {
      // futureContent9.classList.add('-format3');
      // futureContent9.classList.add('-small');
      // futureContent9.classList.remove('-format1');
      // entreContent10.classList.add('-format3');
      // entreContent10.classList.add('-small');
      // entreContent10.classList.remove('-format1');

    } else {
      // futureContent9.classList.add('-format1');
      // futureContent9.classList.remove('-small');
      // futureContent9.classList.remove('-format3');
      // entreContent10.classList.add('-format1');
      // entreContent10.classList.remove('-small');
      // entreContent10.classList.remove('-format3');
    }
  }
  adjustContent();
  window.addEventListener('custom:media', adjustContent);
}

// イベントスライドはPC/SPでナビゲーションの配置が違うのでjsで対処
function initAdjustEvent() {
  function adjustEvent() {
    const nav = document.querySelector('.hrd__event__eventsWrapper__nav');

    if (window.__MEDIA === 'PC') {
      nav.classList.add('-dotCenter');

    } else {
      nav.classList.remove('-dotCenter');
    }
  }
  adjustEvent();
  window.addEventListener('custom:media', adjustEvent);
}

// 動画モーダル
function initModal() {
  const movieTriggers = document.querySelectorAll('[data-movie-id]');
  const modal = document.querySelector('.hrd__modal');
  const video = document.querySelector('.hrd__modal__video');
  for (let trigger of movieTriggers) {
    trigger.addEventListener('click', e => {
      const movieId = trigger.dataset.movieId;
      const html = `<iframe src="https://www.youtube.com/embed/${movieId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`
      video.innerHTML = html;
      modal.classList.add('-open');
    });
  }

  function close() {
    video.innerHTML = '';
    modal.classList.remove('-open');
  }

  modal.addEventListener('click', e => {
    const target = e.target;
    if (target.closest('hrd__modal__close') ||
        !target.closest('hrd__modal__inner')) {
      close();
    }
  });
}